import { QUOTE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { isReadOnlyQuoteProperty } from '../utils/identifiers';
import { useAdditionalPropertyValues } from './useAdditionalPropertyValues';
export const useIsReadOnlyQuoteProperty = (objectTypeId, propertyDefinition) => {
  const {
    data,
    loading
  } = useAdditionalPropertyValues({
    hs_template_type: 'hs_template_type',
    hs_status: 'hs_status',
    hs_locked: 'hs_locked'
  }, {
    skip: objectTypeId !== QUOTE_TYPE_ID || !propertyDefinition.hubspotDefined
  });
  if (loading) {
    return true;
  }
  return isReadOnlyQuoteProperty({
    objectTypeId,
    property: propertyDefinition,
    templateType: data === null || data === void 0 ? void 0 : data.hs_template_type,
    status: data === null || data === void 0 ? void 0 : data.hs_status,
    locked: data === null || data === void 0 ? void 0 : data.hs_locked
  });
};